import { type ResolutionString } from 'charting_library';

export const isTickTimeframe = (timeframe: ResolutionString) => /\d+T/.test(timeframe);
